'use strict';
var widthScreen = $(window).width();

var contLogin,campo,emailRegex;

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.onload = cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.btnFormContacto').on('click',function () {
    $('#formContacto').submit();
});

$("#formContacto").on('submit', function (e) {
    e.preventDefault();
    $('#name').removeClass('error');
    $('#email').removeClass('error');
    $('#cellphone').removeClass('error');
    $('#nameEmp').removeClass('error');
    $('#descrip').removeClass('error');

    contLogin = 1;
    if ( $.trim($("#name").val()) == "" ) {
        contLogin = 0;
        $('#name').addClass('error');
    }

    if ( $.trim($("#email").val()) == "" ) {
        contLogin = 0;
        $('#email').addClass('error');
    }

    if ( $.trim($("#cellphone").val()) == "" ) {
        contLogin = 0;
        $('#cellphone').addClass('error');
    }

    /*if ( $.trim($("#nameEmp").val()) == "" ) {
        contLogin = 0;
        $('#nameEmp').addClass('error');
    }*/

    if ( $.trim($("#descrip").val()) == "" ) {
        contLogin = 0;
        $('#descrip').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    /*campo  = $("#email").val();
    emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (emailRegex.test(campo)) {
        $('#email').removeClass('error');
    } else {
        $('#email').addClass('error');
        swal({
            text: "Debe digitar un correo electrónico valido",
            icon: imageURL,
            button: "OK",
        });
        document.getElementById("emailCon").focus();
        return false;
    }*/

    var data = $(this).serialize();
    $("#formContacto")[0].reset();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: "OK!",
    });
    $.ajax({
        url: https + "contact",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContacto")[0].reset();
                swal({
                    text: "Gracias por registrarte",
                    icon: "success",
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });

});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js